import React from 'react'
import { Redirect } from 'react-router'
import IntegrationsEditPage from '@/views/Integrations/IntegrationsEditPage'
import IntegrationsPage from '@/views/Integrations/IntegrationsPage'
import OrgHierarchyPage from '@/views/OrgHierarchy/OrgHierarchyPage'
import CommandCenterPage from '@/views/CommandCenter/CommandCenterPage'
import PlaybooksPage from '@/views/Playbooks/PlaybooksPage'
import PlaybookEditorPage from '@/views/Playbooks/PlaybookEditorPage'
import OrganizationsPage from '@/views/Organizations/OrganizationsPage'
import OrganizationPage from '@/views/Organizations/OrganizationPage'
import TagPage from '@/views/Organizations/TagPage'
import OrganizationFlagsPage from '@/views/Organizations/OrganizationFlagsPage'
import CallSearchPage from '@/views/Calls/CallSearchPage'
import CallAssetExportsPage from '@/views/Calls/CallAssetExportsPage'
import CallSearchProxy from '@/views/Calls/CallSearchProxy'
import CallExplorerPage from '@/views/Calls/CallExplorerPage'
import KeywordRepositoryPage from '@/views/KeywordRepository/KeywordRepositoryPage'
import LeaderboardsPage from '@/views/Leaderboards/LeaderboardsPage'
import MessagesPage from '@/views/Messages/MessagesPage'
import QACopilotPage from '@/views/QACopilot/QACopilotPage'
import { CostimizerPage } from '@/views/Costimizer/CostimizerPage'
import { CostimizerOrgPage } from '@/views/Costimizer/CostimizerOrgPage'
import { CostimizerScorecardPage } from '@/views/Costimizer/CostimizerScorecardPage'
import AnalyticsPage from '@/views/Analytics/AnalyticsPage'
import ScorecardsPage from '@/views/Scorecards/Scorecards'
import RealtimeCoachingPage from '@/views/RealtimeCoaching/RealtimeCoaching'
import ScorecardEditorPage from '@/views/Scorecards/ScorecardEditorWrapper'
import ViewScoresPage from '@/views/Scorecards/ViewScoresPage/ViewScoresPage'
import ScorecardDashboardPage from '@/views/Scorecards/DashboardPage/DashboardPage'
import ScorecardExportPage from '@/views/Scorecards/ExportsPage/ExportsDashboard'
import ScorecardActivityPage from '@/views/Scorecards/ActivitiesPage/QAActivitiesPage'
import CustomizableDashboardPage from '@/views/QACopilot/CopilotDashboard/dashboard/CustomizableDashboardPage'
import EnterpriseDashboardPage from '@/views/QACopilot/CopilotDashboard/EnterpriseDashboardPage'
import PlaylistPage from '@/views/Playlists/PlaylistPage'
import PlaylistsPage from '@/views/Playlists/PlaylistsPage'
import NotetakerPage from '@/views/Notetaker/NotetakerPage'
import TrendsPage from '@/views/Trends/TrendsPage'
import FeatureFeedbackPage from '@/views/FeatureFeedback/FeatureFeedbackPage'
import { CoachingRedirect } from '@/views/Coaching/CoachingRedirect'
import { CoachingInbox } from '@/views/Coaching/CoachingInbox'
import { ComplianceInbox } from '@/views/Compliance/ComplianceInbox'
import { CalibrationInbox } from '@/views/Calibration/CalibrationInbox'
import { QACopilotInbox } from '@/views/QACopilot/QACopilotInbox'
import { PromptsPage } from '@/views/Analytics/PromptsPage'
import DataCleanupPage from '@/views/Calls/DataCleanupPage'
import InstantDemoPage from '@/views/Calls/InstantDemoPage'
import AutomationInsightsPage from '@/views/AutomationInsights/AutomationInsightsPage'
import DynamicInsightsPage from '@/views/DynamicInsights/DynamicInsightsPage'
import AgenticInsightsPage from '@/views/AgenticInsights/AgenticInsightsPage'
import { LiveListenRedirect } from '@/views/CommandCenter/components/LiveListenRedirect'
import UploadCallsPage from '@/views/UploadCalls/UploadCallsPage'
import { SupervisorActivityPage } from '@/views/Coaching/SupervisorActivityPage'

import { PlaybookMappingPage } from '@/views/PlaybookMapping/PlaybookMappingPage'

import UploadEmailsPage from '@/views/UploadCalls/UploadEmailsPage'
import UploadInteractionsPage from '@/views/UploadCalls/UploadInteractionsPage'
import { AiAnswersPage } from '@/views/AiAnswers/AiAnswersPage'
import BaltoAcademyPage from '@/views/BaltoAcademy/BaltoAcademyPage'
import BaltoAcademyCoursePage from '@/views/BaltoAcademy/BaltoAcademyCoursePage'
import BaltoAcademyReportingPage from '@/views/BaltoAcademy/BaltoAcademyReportingPage'
import BaltoAcademyUserPage from '@/views/BaltoAcademy/BaltoAcademyUserPage'
import { AudioIngestionRecordsPage } from '@/views/UploadCalls/AudioIngestionRecordsPage'
import ToolsPage from '@/views/Tools/ToolsPage'
import ToolFormPage from '@/views/Tools/ToolFormPage'
import BulkRescorePage from '@/views/BulkRescore/BulkRescorePage'

import { CampaignsPage } from '@/views/Outbound/CampaignsPage'
import { ContactListsPage } from '@/views/Outbound/ContactListsPage'
import { KodiPage } from '@/views/Kodi/KodiPage'
import OmnichannelUsagePage from '@/views/OmnichannelUsage/OmnichannelUsagePage'
import KodiUsagePage from '@/views/KodiUsage/KodiUsagePage'
import { KodiReportsPage } from '@/views/KodiReports/KodiReportsPage'
import SupportAccessPage from '@/views/SupportAccess/SupportAccessPage'
import { ConnectedAppsPage } from '@/views/OAuth/ConnectedAppsPage'

import VoiceAgentsPage from '@/views/VoiceAgents/VoiceAgentsPage'
import VoiceAgentsListPage from '@/views/VoiceAgents/VoiceAgentsListPage'
import CreateAgentPage from '@/views/VoiceAgents/CreateAgentPage'
import { TogoAnalyticsPage } from '@/views/Togo/TogoAnalyticsPage'
import { PERMISSIONS } from '@/reducers/auth/currentUser.redux'

import IndexRedirect from './IndexRedirect'

export const protectedRoutes = [
  {
    path: '/',
    Component: IndexRedirect,
  },

  {
    path: '/call-explorer/:id',
    Component: ({ location }) => {
      const id = location.pathname.split('/call-explorer/')[1].split('?')[0]
      return <Redirect to={{ pathname: `/calls/${id}`, search: location.search }} />
    },
  },
  {
    path: '/call-explorer',
    Component: ({ location }) => (
      <Redirect to={{ pathname: '/explorer', search: location?.search }} />
    ),
  },
  {
    path: '/command-center',
    Component: LiveListenRedirect,
    pageTitle: 'Live Listen',
  },

  {
    path: '/live-listen',
    Component: CommandCenterPage,
    pageTitle: 'Live Listen',
  },

  {
    path: '/playbooks',
    Component: PlaybooksPage,
    pageTitle: 'Playbooks',
  },

  {
    path: '/ai-answers',
    Component: AiAnswersPage,
    pageTitle: 'AI Answers',
  },

  // New playbook editor
  {
    path: '/playbooks/:id',
    Component: PlaybookEditorPage,
    pageTitle: 'Redirecting...',
  },
  {
    path: '/playbooks/:id/:section',
    Component: PlaybookEditorPage,
    pageTitle: 'Playbook Editor',
  },
  {
    path: '/playbooks/:id/:section/:entryId',
    Component: PlaybookEditorPage,
    pageTitle: 'Playbook Editor',
  },

  {
    path: '/reports/:section?',
    Component: AnalyticsPage,
  },

  {
    path: '/users',
    Component: OrganizationPage,
    pageTitle: 'Users',
    requiredPermission: PERMISSIONS.USERS_READ,
  },
  {
    path: '/users/tags',
    Component: TagPage,
    pageTitle: 'User Tag Manager',
    requiredPermission: PERMISSIONS.USERS_READ,
  },

  {
    path: '/leaderboards',
    Component: LeaderboardsPage,
    pageTitle: 'Leaderboards',
  },
  // QA Routes
  {
    path: '/scorecards',
    Component: ScorecardsPage,
    qaRoute: true,
    pageTitle: 'Scorecards',
  },
  {
    path: '/scorecards/dashboard',
    Component: ScorecardDashboardPage,
    qaRoute: true,
    pageTitle: 'Score Dashboard',
  },
  {
    path: '/scorecards/dashboard/overview',
    Component: ScorecardDashboardPage,
    qaRoute: true,
    componentProps: { tab: 'Overview' },
    pageTitle: 'Score Dashboard',
  },
  {
    path: '/scorecards/dashboard/live',
    Component: ScorecardDashboardPage,
    qaRoute: true,
    componentProps: { tab: 'Live Feed' },
    pageTitle: 'Score Dashboard',
  },
  {
    path: '/scorecards/view_scores',
    Component: ViewScoresPage,
    componentProps: { copilot: false },
    qaRoute: true,
    pageTitle: 'Scores',
  },
  {
    path: '/scorecards/exports',
    Component: ScorecardExportPage,
    qaRoute: true,
    pageTitle: 'Export Scores',
  },
  {
    path: '/scorecards/activity',
    Component: ScorecardActivityPage,
    qaRoute: true,
    pageTitle: 'QA Activity',
  },
  {
    path: '/scorecards/edit_config/:scorecard_config_id',
    Component: ScorecardEditorPage,
    qaRoute: true,
    pageTitle: 'Scorecard Editor',
  },
  {
    path: '/scorecards/edit_config/:scorecard_config_id/edit_section/:scorecard_section_id',
    Component: ScorecardEditorPage,
    qaRoute: true,
    pageTitle: 'Score Dashboard',
  },
  // Copilot routes
  {
    path: '/qa-copilot',
    Component: ScorecardsPage,
    qaCopilotRoute: true,
    pageTitle: 'Quality Scorecards',
  },
  {
    path: '/qa-copilot/dashboard',
    Component: CustomizableDashboardPage,
    qaCopilotRoute: true,
    pageTitle: 'Quality Dashboard',
  },
  {
    // The classic dashboard's migration window closed 2026-08-31. Its
    // banner spent 45 days pointing here, so the URL redirects rather
    // than 404ing the bookmarks that banner created.
    path: '/qa-copilot/dashboard/classic',
    Component: ({ location }) => (
      <Redirect to={{ pathname: '/qa-copilot/dashboard', search: location?.search }} />
    ),
    qaCopilotRoute: true,
  },
  {
    path: '/qa-copilot/enterprise',
    Component: EnterpriseDashboardPage,
    qaCopilotRoute: true,
    pageTitle: 'Quality Enterprise Dashboard',
  },
  {
    // Retired with the classic dashboard: this page's job moved into the
    // new dashboard's scored-calls browser and drill-down drawers. The
    // RTQ scores page at /scorecards/view_scores is the same component
    // and is unaffected.
    //
    // The query string is deliberately dropped, unlike the classic
    // dashboard redirect above. This page's params were agent_id /
    // agent_name, which the dashboard's bootstrap doesn't recognise --
    // and it gates on `!isEmpty(params)`, so forwarding them would trip
    // that gate for Balto admins and hierarchy managers while supplying
    // no usable filter. Landing clean is the honest result.
    path: '/qa-copilot/view_scores',
    Component: () => <Redirect to={{ pathname: '/qa-copilot/dashboard' }} />,
    qaCopilotRoute: true,
  },
  {
    path: '/qa-copilot/exports',
    Component: ScorecardExportPage,
    qaCopilotRoute: true,
    pageTitle: 'Export Scores',
  },
  {
    path: '/qa-copilot/activity',
    Component: ScorecardActivityPage,
    qaCopilotRoute: true,
    pageTitle: 'QA Activity',
  },
  {
    path: '/qa-copilot/inbox',
    Component: QACopilotInbox,
    pageTitle: 'Quality Inbox',
  },
  {
    path: '/qa-copilot/:id',
    Component: QACopilotPage,
    qaCopilotRoute: true,
    pageTitle: 'Quality Scorecard',
  },
  // Real-Time Coaching Routes
  {
    path: '/realtime_coaching/:section',
    Component: RealtimeCoachingPage,
    pageTitle: 'Real-Time Coaching',
    requiredPermission: PERMISSIONS.REALTIME_COACHING_READ,
  },
  {
    path: '/realtime_coaching/reports/:subsection',
    Component: RealtimeCoachingPage,
    pageTitle: 'Real Time Reports',
    requiredPermission: PERMISSIONS.REALTIME_COACHING_READ,
  },

  // Admin Routes
  // Deliberately not in the sidebar — reached by typing /costimizer.
  {
    path: '/costimizer',
    Component: CostimizerPage,
    adminOnly: true,
    pageTitle: 'Costimizer',
  },
  {
    path: '/costimizer/:organizationId',
    Component: CostimizerOrgPage,
    adminOnly: true,
    pageTitle: 'Costimizer',
  },
  {
    path: '/costimizer/:organizationId/:scorecardConfigId',
    Component: CostimizerScorecardPage,
    adminOnly: true,
    pageTitle: 'Costimizer',
  },
  {
    path: '/organizations',
    Component: OrganizationsPage,
    adminOnly: true,
    pageTitle: 'Organizations',
    dataGrid: true,
    dataGridColumn: true,
  },
  {
    path: '/organizations/:organizationid',
    Component: OrganizationPage,
    adminOnly: true,
    pageTitle: 'Organization Detail',
  },
  {
    path: '/organizations/:organizationid/tags',
    Component: TagPage,
    adminOnly: true,
    pageTitle: 'Organization Tag Manager',
  },
  {
    path: '/organizations/:organizationid/flags',
    Component: OrganizationFlagsPage,
    adminOnly: true,
    pageTitle: 'Organization Flags',
  },
  {
    path: '/organizations/:organizationid/hierarchy',
    Component: OrgHierarchyPage,
    adminOnly: true,
    pageTitle: 'Organization Hierarchy',
  },
  {
    path: '/playbook_mapping',
    Component: PlaybookMappingPage,
    pageTitle: 'Playbook Mapping',
  },
  {
    path: '/calls',
    Component: CallSearchProxy,
    pageTitle: 'Call Explorer',
  }, // TODO: Remove this
  {
    path: '/calls/:id',
    Component: CallExplorerPage,
    pageTitle: 'Call Detail',
  },
  {
    path: '/messages/:id',
    Component: MessagesPage,
    pageTitle: 'Messages',
  },
  {
    path: '/explorer',
    Component: CallSearchPage,
    pageTitle: 'Explorer',
    dataGrid: true,
    dataGridColumn: true,
  },
  {
    // Reachable without a link, which is the point: notifications get
    // dismissed and emails get deleted, and a colleague's export is otherwise
    // unreachable even though anyone with Cloud access may open it.
    //
    // One entry covering both URLs, not two. App.js keys each route on its
    // path, so a second entry for `/exports/:id` would give the drawer its
    // own key and remount the page -- and reset the organization picker --
    // on every open and close. `:id?` is the same shape as `/reports/:section?`.
    //
    // The id is in the path rather than a query param because this is where
    // the notifications and the completion email land: an unauthenticated
    // visit redirects to login, and `?next=` preserves the pathname only.
    path: '/exports/:id?',
    Component: CallAssetExportsPage,
    pageTitle: 'Exports',
    cloudAccessRoute: true,
    // No admin exception, unlike cloudAccessRoute's default. The reporting
    // API's require_balto_cloud_access has none, so a Balto admin without
    // Cloud Access reaching this page by URL would meet a 403 on every call.
    noBaltoAdminException: true,
  },
  {
    path: '/instant-demo',
    Component: InstantDemoPage,
    pageTitle: 'Instant Demo',
    adminOnly: true,
  },
  {
    path: '/automation-insights',
    Component: AutomationInsightsPage,
    pageTitle: 'Automation Insights',
    adminOnly: true,
  },
  {
    path: '/keywords_repository/:language(english|spanish)?',
    Component: KeywordRepositoryPage,
    adminOnly: true,
    pageTitle: 'Keyword Repository',
  },
  {
    path: '/erase_customer_data',
    Component: DataCleanupPage,
    adminOnly: true,
    pageTitle: 'Data Cleanup',
  },
  {
    path: '/integrations',
    Component: IntegrationsPage,
    adminOnly: true,
    pageTitle: 'Integrations',
  },
  {
    path: '/integrations/edit_config/:integration_config_id',
    Component: IntegrationsEditPage,
    qaRoute: true,
    componentProps: { tab: 'Connector Config' },
    pageTitle: 'Integration Editor',
  },

  // Playlists
  {
    path: '/playlists',
    Component: PlaylistsPage,
    pageTitle: 'Playlists',
  },
  {
    path: '/playlists/:playlistUuid',
    Component: PlaylistPage,
    pageTitle: 'Playlist',
    dataGrid: true,
    dataGridColumn: true,
  },

  // Notetaker
  {
    path: '/realtime-notetaker',
    Component: ({ location }) => (
      <Redirect to={{ pathname: '/notetaker', search: location?.search }} />
    ),
  },
  {
    path: '/notetaker',
    Component: NotetakerPage,
    pageTitle: 'Notetaker',
  },
  {
    path: '/feature-feedback',
    Component: FeatureFeedbackPage,
    pageTitle: 'Feature Feedback',
  },
  {
    path: '/coaching/scorecards',
    Component: ScorecardsPage,
    pageTitle: 'Coaching Scorecard',
    adminOnly: true,
    qaCopilotRoute: true,
  },
  {
    path: '/coaching',
    Component: CoachingRedirect,
    pageTitle: 'Coaching Opportunities',
  },
  {
    path: '/coaching/inbox',
    Component: CoachingInbox,
    pageTitle: 'Coaching Inbox',
  },
  {
    path: '/coaching/scorecards/edit_config/:scorecard_config_id',
    Component: ScorecardEditorPage,
    qaCopilotRoute: true,
    adminOnly: true,
    pageTitle: 'Scorecard Editor',
  },
  {
    path: '/coaching/scorecards/edit_config/:scorecard_config_id/edit_section/:scorecard_section_id',
    Component: ScorecardEditorPage,
    qaCopilotRoute: true,
    adminOnly: true,
    pageTitle: 'Score Dashboard',
  },
  {
    path: '/coaching/scorecards/:id',
    Component: QACopilotPage,
    qaCopilotRoute: true,
    adminOnly: true,
    pageTitle: 'Coaching Scorecard',
  },
  // Compliance
  {
    path: '/compliance/inbox',
    Component: ComplianceInbox,
    pageTitle: 'Compliance Inbox',
    requiredPermission: PERMISSIONS.COMPLIANCE_READ,
  },
  // Calibration (unified prompt engineering + customer feedback)
  {
    path: '/quality/calibration',
    Component: CalibrationInbox,
    pageTitle: 'Calibration',
    qaCopilotRoute: true,
  },
  // Trends
  {
    path: '/trends',
    Component: TrendsPage,
    pageTitle: 'Trends',
  },
  {
    path: '/discover',
    Component: DynamicInsightsPage,
    pageTitle: 'Discover',
  },
  {
    path: '/agentic-insights',
    Component: AgenticInsightsPage,
    pageTitle: 'Agentic Insights',
    dataGrid: true,
    alexInsightsRoute: true,
  },
  // AI Prompts Page
  {
    path: '/ai_usage',
    Component: PromptsPage,
    pageTitle: 'AI Usage',
  },
  // Kodi usage reporting. Balto-admin (org 1) only; backend enforces the same gate.
  {
    path: '/kodi-usage',
    Component: KodiUsagePage,
    pageTitle: 'Kodi Usage',
    adminOnly: true,
  },
  // Omnichannel Usage Dashboard (QCER-777). Manager-only via `cloudAccessRoute`
  // (Balto Cloud Access). Backend enforces the same gate.
  {
    path: '/omnichannel-usage',
    Component: OmnichannelUsagePage,
    pageTitle: 'Omnichannel Usage',
    cloudAccessRoute: true,
  },

  // Balto Support Access (QCER-802). Visible to users with manage_support_access;
  // gated by supportAccessRoute in ProtectedRoute.
  {
    path: '/support-access',
    Component: SupportAccessPage,
    pageTitle: 'Balto Support Access',
    supportAccessRoute: true,
  },
  {
    path: '/connected-apps',
    Component: ConnectedAppsPage,
    pageTitle: 'Connected Apps',
  },
  // Upload Interactions Page
  {
    path: '/upload-interactions',
    Component: UploadInteractionsPage,
    pageTitle: 'Upload Interactions',
  },
  {
    path: '/audio-ingestion-records',
    Component: AudioIngestionRecordsPage,
    pageTitle: 'Audio Ingestion Records',
    dataGrid: true,
    dataGridColumn: true,
  },
  // Call Upload Page
  {
    path: '/upload-calls',
    Component: UploadCallsPage,
    pageTitle: 'Upload Calls',
  },

  {
    path: '/supervisor-usage',
    Component: SupervisorActivityPage,
    pageTitle: 'Supervisor Usage',
  },
  {
    path: '/upload-emails',
    Component: UploadEmailsPage,
    pageTitle: 'Upload Emails',
  },
  {
    path: '/balto-academy',
    Component: BaltoAcademyPage,
    pageTitle: 'Balto Academy',
  },
  {
    path: '/balto-academy/reporting',
    Component: BaltoAcademyReportingPage,
    pageTitle: 'Balto Academy Reporting',
  },
  {
    path: '/balto-academy/reporting/user',
    Component: BaltoAcademyUserPage,
    pageTitle: 'Balto Academy User',
  },
  {
    path: '/balto-academy/:courseId',
    Component: BaltoAcademyCoursePage,
    pageTitle: 'Balto Academy Course',
  },
  {
    path: '/bulk-rescore',
    Component: BulkRescorePage,
    adminOnly: true,
    pageTitle: 'Bulk Operations',
  },
  {
    path: '/tools',
    Component: ToolsPage,
    toolsEditorRoute: true,
    pageTitle: 'Tools',
  },
  {
    path: '/tools/:id',
    Component: ToolFormPage,
    toolsEditorRoute: true,
    pageTitle: 'Tool',
  },

  // Outbound
  {
    path: '/campaigns',
    Component: CampaignsPage,
    pageTitle: 'Campaigns',
    outboundCampaignsRoute: true,
  },
  {
    path: '/contact-lists',
    Component: ContactListsPage,
    pageTitle: 'Contact Lists',
    outboundCampaignsRoute: true,
  },

  // Cowork
  {
    path: '/kodi/:id?',
    Component: KodiPage,
    pageTitle: 'Kodi',
    dataGrid: true,
  },
  // Pinned Kodi charts. Same gate as starting a Kodi session; the page redirects
  // anyone without it and the backend enforces it.
  {
    path: '/kodi-reports',
    Component: KodiReportsPage,
    pageTitle: 'Kodi Reports',
  },

  // Togo — combined voice-agent + outbound analytics.
  {
    path: '/togo/analytics',
    Component: TogoAnalyticsPage,
    pageTitle: 'Analytics',
    togoAnalyticsRoute: true,
  },

  // Voice Agents — prompt externalization. Gated to Togo editors (togo_editor +
  // togo_enabled); admins bypass. The in-page admin affordances (org switching,
  // extra columns) stay gated on isBaltoAdmin inside the components.
  {
    path: '/voice-agents',
    Component: VoiceAgentsListPage,
    pageTitle: 'Agent Studio',
    exact: true,
    togoEditorRoute: true,
  },
  // Guided agent-creation wizard (AVR-435). Registered BEFORE the
  // `:agentId(.+)` catch-all below, which would otherwise match "create".
  // All-or-nothing: provisioning is atomic, so there's no resumable state and
  // no per-agent create URL.
  {
    path: '/voice-agents/create',
    Component: CreateAgentPage,
    pageTitle: 'Create AI Agent',
    // Provisioning a new agent is a Balto-admin (org 1) operation. adminOnly is
    // checked before the togo gate, so a non-admin who types this URL is
    // redirected rather than reaching the wizard.
    adminOnly: true,
    togoEditorRoute: true,
  },
  {
    path: '/voice-agents/by-user/:userId(\\d+)',
    Component: VoiceAgentsPage,
    pageTitle: 'AI Agents',
    dataGrid: true,
    togoEditorRoute: true,
  },
  {
    path: '/voice-agents/:agentId(.+)',
    Component: VoiceAgentsPage,
    pageTitle: 'AI Agents',
    dataGrid: true,
    togoEditorRoute: true,
  },
]
